import { createI18n } from 'vue-i18n';
import messages from '@/plugins/translator/translations';

export default createI18n({
    locale: localStorage.getItem('locale') ?? 'en',
    messages: messages
});
